export const mockEvent = {
  id: 100,
  name: 'onboarding_details.json',
  size: '1200 KB',
};

export const mockDeleteEndpoint = 'api/delete/';

export const mockUploadedFiles = [
  { id: 101, name: 'enrollment.json', size: '1500 KB' },
  { id: 102, name: 'employee_details.json', size: '1600 KB' },
];

export const mockDocumentBucket = { type: 'json' };
